<template>
  <div style="display: flex; flex-direction: row; height: 100%;">
    <FormEditor v-if="pageData.loadType !== '0'" ref="formEditor" v-model="design" mode="review" :locale="locale" :appId="mixinAppId" :pageId="mixinPageId" class="form-editor" />
    <iframe v-else :src="pageData.loadPath" style="width: 100%; height: 100%; border: none; margin: 0;"></iframe>
  </div>
</template>
<script>
import FormEditor from '@/components/FormEditor'
import { getDisplayData } from '@/api/app/page'
import { mapActions } from 'vuex'
import RouteQueryMixins from '@/mixins/RouteQueryMixins'
import LanguageSwitchMixin from './mixins/LanguageSwitchMixin'

export default {
  components: {
    FormEditor,
  },
  data() {
    return {
      pageData: {},
      design: {},
      originDesign: {},
      pageKey: null
    }
  },
  mixins: [RouteQueryMixins, LanguageSwitchMixin],
  computed: {
    locale() {
      return this.$store.getters.lang.lang
    },
    userInfo() {
      return this.$store.getters.user
    }
  },
  watch: {
    '$route': {
      handler(newVal) {
        const route = newVal
        if (!(route.matched?.length)) {
          return
        }
        const component = route.matched[route.matched.length - 1]
        const vueComponent = component.instances?.default
        if (vueComponent != this) {
          return
        }
        const { pageKey } = newVal.query
        if (this.pageKey == pageKey) {
          return
        }
        this.resetData()
      },
      immediate: true,
      deep: true
    },
    'locale': {
      handler(val) {
        const design = JSON.parse(JSON.stringify(this.originDesign))
        this.resetLabelByLanguage(design, this.getLanguageMap(design))
        this.design = design
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    ...mapActions(['setPageData']),
    loadData() {
      getDisplayData({ pageId: this.mixinPageId, env: this.$route.query.env || '2' }).then(res => {
        this.pageData = { ...res.data }
        if (this.pageData.loadType === '0') {
          return
        }
        const designStr = this.pageData.design
        const design = designStr && designStr.length > 0 ? JSON.parse(designStr) : { 'type': 'page', 'body': [] }
        const data = design.data || {}
        const permissions = data.permissions || this.$store.getters.user.permissions
        data.permissions = permissions
        data.lang = data.lang || this.$store.getters.lang.lang
        data.userInfo = data.userInfo || this.userInfo
        design.data = data
        this.originDesign = JSON.parse(JSON.stringify(design))
        this.resetLabelByLanguage(design, this.getLanguageMap(design))
        if (!design.type) {
          design.type = 'page'
        }
        this.design = design
        this.setPageData(res.data)
      })
    },
    resetData() {
      this.pageKey = this.$route.query.pageKey
      this.pageData = {}
      this.design = {}
      this.loadData()
    },
  }
}
</script>
<style lang="less" scoped>

.form-editor {

  width: 100%;

  ::v-deep .cxd-Table-fixedTop::after {
    height: 100%;
    box-shadow: none;
  }
}
</style>